import React from 'react';
import { UtensilsCrossed, Coffee, Salad, Wine, Beer, Leaf, WheatOff, CakeSlice, Info, Clock, ChefHat, GlassWater } from 'lucide-react';
export function MenusSection() {
  const menuItems = [{
    name: 'Breakfast',
    icon: Coffee
  }, {
    name: 'Lunch',
    icon: UtensilsCrossed
  }, {
    name: 'Early Bird',
    icon: Clock
  }, {
    name: 'Starters',
    icon: ChefHat
  }, {
    name: 'A La Carte',
    icon: UtensilsCrossed
  }, {
    name: 'Taste of Ireland',
    icon: Leaf
  }, {
    name: 'Vegetarian',
    icon: Salad
  }, {
    name: 'Flour Free',
    icon: WheatOff
  }, {
    name: 'Desserts',
    icon: CakeSlice
  }, {
    name: 'Wine List',
    icon: Wine
  }, {
    name: 'Drinks',
    icon: Beer
  }, {
    name: 'Allergens',
    icon: Info
  }];
  return <section id="menus" className="py-20 md:py-24 bg-surface/30 border-y border-border/50" data-id="element-244">
      <div className="container mx-auto px-4" data-id="element-245">
        <div className="text-center mb-16" data-id="element-246">
          <h2 className="font-serif text-3xl md:text-5xl font-bold text-foreground mb-4 relative inline-block" data-id="element-247">
            Our Menus
            <span className="absolute -bottom-2 left-0 right-0 h-1 bg-primary rounded-full opacity-80" data-id="element-248"></span>
          </h2>
          <p className="text-muted-foreground text-lg mt-4" data-id="element-249">
            Discover our wide range of traditional and modern options
          </p>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6" data-id="element-250">
          {menuItems.map(item => <a key={item.name} href="https://oldmillrestaurant.ie/menus/" target="_blank" rel="noopener noreferrer" className="group flex flex-col items-center justify-center p-6 bg-card rounded-lg border border-border hover:border-primary hover:bg-accent/50 transition-all duration-300 hover:-translate-y-1" data-id="element-251">
              <div className="w-12 h-12 rounded-full bg-primary/10 flex items-center justify-center mb-4 group-hover:bg-primary group-hover:text-primary-foreground transition-all duration-300" data-id="element-252">
                <item.icon className="w-6 h-6 text-primary group-hover:text-primary-foreground transition-colors" data-id="element-253" />
              </div>
              <span className="font-serif text-lg font-medium text-foreground group-hover:text-primary transition-colors" data-id="element-254">
                {item.name}
              </span>
            </a>)}
        </div>
      </div>
    </section>;
}